// extracted by mini-css-extract-plugin
export default {"table":"Table_table__EmFlm","tableHeader":"Table_tableHeader__VT-hY"};